import { render, staticRenderFns } from "./QueueOverview.vue?vue&type=template&id=65dd2d58&"
import script from "./QueueOverview.vue?vue&type=script&lang=js&"
export * from "./QueueOverview.vue?vue&type=script&lang=js&"
import style0 from "./QueueOverview.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports